import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { getAvailableProgramTypes } from 'partner360/helpers/offerings/getAvailableProgramTypes'
import { getOfferingsInfo } from 'partner360/helpers/offerings/getOfferingsInfo'

import type { ICockpitPartnerOfferingsCatalog } from '../model/types'

/** Each enabled offering's `orderBy`, first-seen across the partner catalog — the same
 *  "earliest partner wins" convention `getEnabledCockpitOfferings`/`getManagerOfferingsInfo` use
 *  for the offering name/counts, so every offering-ordered view in Financial Cockpit agrees on one
 *  order. */
export const getOfferingOrderMap = (
  offeringsCatalog: ICockpitPartnerOfferingsCatalog[]
): Map<ProgramTypes, number> => {
  const orderByOffering = new Map<ProgramTypes, number>()

  offeringsCatalog.forEach(({ offerings }) => {
    const { enabledOfferings } = getOfferingsInfo(getAvailableProgramTypes(offerings))
    enabledOfferings.forEach(({ programType, orderBy }) => {
      if (!orderByOffering.has(programType)) orderByOffering.set(programType, orderBy)
    })
  })

  return orderByOffering
}
